var _defs, _rect, _path, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120 120",
    width: 120,
    height: 120,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "pp-g",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#C2410C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F97316"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    rx: 18,
    fill: "#0F172A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60 20 C 40 42, 36 60, 52 76 C 46 72, 44 64, 48 56 C 52 68, 60 70, 68 60 C 66 72, 72 80, 82 76 C 76 90, 60 94, 48 86 C 32 76, 32 50, 60 20 Z",
    fill: "url(#pp-g)"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 106,
    textAnchor: "middle",
    fontFamily: "Helvetica, Arial, sans-serif",
    fontSize: 14,
    fontWeight: 800,
    fill: "#F8FAFC",
    letterSpacing: 2
  }, "PP")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.16e89383149ac67e82f799447313bb65.svg";
export { ForwardRef as ReactComponent };